import user from './user';

export default {
  namespaced: true,
  modules: {
    user,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js